import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const ProfilIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 21.37 21.44" {...props}>
    <path
      id="perso"
      d="M10.73,0A10.72,10.72,0,0,0,0,10.72H0A10.84,10.84,0,0,0,7.5,21a10.1,10.1,0,0,0,3.23.5h0A10.74,10.74,0,0,0,10.73,0Zm0,1.07h0a9.65,9.65,0,0,1,9.65,9.65h0a9.54,9.54,0,0,1-1.28,4.83,11.12,11.12,0,0,0-1.68-1.68A10.72,10.72,0,0,0,2.36,15.56a9.78,9.78,0,0,1-1.28-4.83v0A9.62,9.62,0,0,1,10.7,1.07ZM5,14.52a9.66,9.66,0,0,1,13.53,2A9.66,9.66,0,0,1,5,18.48a9.83,9.83,0,0,1-2-2A10,10,0,0,1,5,14.52ZM10.73,3a3.76,3.76,0,1,0,3.76,3.76A3.76,3.76,0,0,0,10.73,3Zm0,6.44a2.69,2.69,0,1,1,0-5.37h0A2.68,2.68,0,0,1,13.4,6.69v0a2.68,2.68,0,0,1-2.68,2.68Z"
      fillRule="evenodd"
    />
  </SvgIcon>
));

export default React.memo(ProfilIcon);
